module.exports = __webpack_public_path__ + "img/zkhd-overview.ad62ed98.jpg";